export default __webpack_public_path__ + "bg3ffa68f.png";